import type { CommonPowerSyncDatabase } from '@powersync/common';
import { PowerSyncDatabase } from '@powersync/web';

import { DEMO_DB_FILENAME, demoSchema } from './schema';

// Local-only: connect() is never called, so nothing syncs. Defaults apply:
// IndexedDB storage, with the database worker bundled by webpack
// (docs.powersync.com/client-sdks/reference/javascript-web).
// Not encrypted: the web keychain is a localStorage shim, so a key would sit
// beside the data.
export async function createDemoDatabase(): Promise<CommonPowerSyncDatabase> {
  const db = new PowerSyncDatabase({
    schema: demoSchema,
    database: { dbFilename: DEMO_DB_FILENAME },
  });
  await db.init();
  return db;
}
